import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission.js';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
	name: "OrganisationOverdueBills",
	entity: "organisationOverdueBills",
	graphQL: "OrganisationOverdueBill",
	dynamoPrefix: 'org',
	storageType: 'central',
	defaultTitle: (data) => {
		return data['code'];
	},
	writePermission: [
		Permission.PERM_DEVELOPER,
	],
	createPermission: [
		Permission.PERM_DEVELOPER,
	],
	fields: (types) => ({
		id: {
			type: "id",
			defaultValue: () => uuidv4(),
			primaryKey: true,
			required: true,
			userEditable: false,
			description: "Unique identifier for the overdue bill"
		},
		code: {
			type: "string",
			required: true,
			userEditable: false,
		},
		organisation: {
			name: "Organisation",
			to: () => types['organisations'],
			type: "relation",
			required: true,
			userEditable: false,
			hiddenCreate: true,
		},
		amountToPay: {
			type: "integer",
			required: true,
			userEditable: true,
		},
		totalAmount: {
			type: "integer",
			required: true,
			userEditable: true,
		},
		variableSymbol: {
			type: "string",
			required: false,
			userEditable: false,
			description: "Variable symbol (varSym) from Flexi",
		},
		dueDate: {
			type: "datetime",
			required: true,
			userEditable: true,
		},
		isIgnored: {
			type: "boolean",
			required: false,
			userEditable: true,
			defaultValue: false,
		},
		adminsNotified: {
			type: "boolean",
			description: "Flag to indicate if the admins have been notified about the bill",
			defaultValue: false,
		},
		usersNotified: {
			type: "boolean",
			description: "Flag to indicate if the users have been notified about the bill",
			defaultValue: false,
		},
		updatedAt: {
			name: "Updated At",
			type: "datetime",
			defaultValue: () => new Date(),
			userEditable: false,
		},
		createdAt: {
			name: "Created At",
			type: "datetime",
			defaultValue: () => new Date(),
			userEditable: false,
		},
		currencyCode: {
			type: "string",
			required: true,
			userEditable: false,
			description: "Currency code of the bill, e.g., 'CZK', 'EUR'"
		},
		remindSince: {
			name: "Remind Since",
			type: "datetime",
			required: false,
			userEditable: false
		},
	}),
	relations: (types) => ({
		logs: {
			type: 'oneToMany',
			to: types['organisationOverdueBillLogs'],
			foreignKeys: [
				{ from: "id", to: "organisationOverdueBill_id" }
			]
		},
		blocked_organisations: {
			type: 'manyToMany',
			to: types['organisations'],
			foreignKeys: [
				{ from: "id", to: "blocked" }
			]
		},
	}),
	getBL: function() {
			return {
				canCreate: function(permissionObject, data) {
					return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
				},
				canUpdate: function(permissionObject, data) {
					return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
				},
				canDelete: function(permissionObject, data) {
					return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
				},
				canRead: function(permissionObject, data) {
					return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
				},
			};
		},
});


